
import { Component, Vue } from 'vue-property-decorator'
import eventBus from '../plugins/eventBus'
import { addToCartSuccess } from '@/plugins/popups'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import { ItemModel } from '@/store/models/ItemModel'

@Component({})
export default class ItemModal extends Vue {
  item: ItemModel = ItemModel.getInstance()
  envConfigurations: any = envConfiguration
  sectorId: number = null

  addToFavorites(item: any) {
    item.addToFavorites()
  }

  addToCart(item: any) {
    if (item.outOfStock) {
      return
    }
    eventBus.$emit('cart:from-modal', item)
    addToCartSuccess()
  }

  hideModal() {
    this.$modal.hide('itemModal')
  }

  mounted() {
    eventBus.$on('item_modal', (data: ItemModel) => {
      this.$modal.show('itemModal')
      this.item = data
    })
    this.sectorId = this.envConfigurations.sectorID
  }
}
